module.exports = __webpack_public_path__ + "static/media/logo.9adf1285.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/logo.svg
// module id = 1597
// module chunks = 0